const Icon: React.FC<IconProps> = ({ color = "white", width = "26px", height = "26px" }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M12.25 6.0397C8.73668 6.41393 6 9.38737 6 13C6 16.866 9.13401 20 13 20C14.6628 20 16.1902 19.4202 17.3911 18.4518L12.4697 13.5303L12.25 13.3107V13V6.0397ZM18.4518 17.3911C19.3223 16.3116 19.8788 14.9683 19.9824 13.5L14.5607 13.5L18.4518 17.3911ZM19.9291 12L13.75 12V6.0397C16.9331 6.37876 19.4787 8.85143 19.9291 12Z" fill={color} />
      <circle cx="13" cy="13" r="11.25" stroke={color} strokeWidth="1.5" />
    </svg>
  );
};

export default Icon;
